export default {
  AnnualDP: { value: 'ANDP', text: 'Annual DP' },
  YearlyFMEA: { value: 'FMEA', text: '5 Yearly FMEA DP' }
}
